import OpticksLink from "@/components/ui/OpticksLink/OpticksLink";
import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step_1_4_1 from "@/assets/integration-steps/reddit/step_1_4_1.png";
import step_1_4_2 from "@/assets/integration-steps/reddit/step_1_4_2.png";

interface Props {
  stepLabel?: string;
}

const RedditIntegrationStep4 = ({ stepLabel }: Props) => (
  <div className="channels-integration-step reddit-step-4">
    <div className="step-label-row">
      {stepLabel && <OpticksNumberCircle number={stepLabel} />}
      <h6>Assign audience to Ad Groups</h6>
    </div>
    <div className="wrapper">
      <p>
        You can now assign this new audience to <b>Ad Groups</b> so they exclude
        the invalid traffic.
      </p>
      <br />
      <img src={step_1_4_1} alt="Screenshot of step 1.4.1 Reddit Integration" />
      <br />
      <p>
        Go to the{" "}
        <OpticksLink
          href="https://ads.reddit.com/dashboard?entity=adgroups"
          label="Ad Groups list"
        />
        , click on the <b>"⋮"</b> then <b>"Edit ad group"</b>, and scroll to{" "}
        <b>"Excluded custom audiences"</b> under section{" "}
        <b>"Custom audiences"</b>, and add it here.
      </p>
      <br />
      <img src={step_1_4_2} alt="Screenshot of step 1.4.2 Reddit Integration" />
      <br />
      <p>
        If creating a new Ad Group, the option appears under section{" "}
        <b>"Audience controls"</b> but is hidden by default and you need to
        click <b>"View more options"</b>.
      </p>
    </div>
  </div>
);

export default RedditIntegrationStep4;
